module.exports = __webpack_public_path__ + "static/media/notification.e50d08cd.mp3";